import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/engine/sites',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::index
* @see app/Http/Controllers/Admin/SitesController.php:24
* @route '/engine/sites'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\SitesController::updateNotes
* @see app/Http/Controllers/Admin/SitesController.php:88
* @route '/engine/sites/{site}/notes'
*/
export const updateNotes = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateNotes.url(args, options),
    method: 'patch',
})

updateNotes.definition = {
    methods: ["patch"],
    url: '/engine/sites/{site}/notes',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\SitesController::updateNotes
* @see app/Http/Controllers/Admin/SitesController.php:88
* @route '/engine/sites/{site}/notes'
*/
updateNotes.url = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return updateNotes.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SitesController::updateNotes
* @see app/Http/Controllers/Admin/SitesController.php:88
* @route '/engine/sites/{site}/notes'
*/
updateNotes.patch = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateNotes.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::updateNotes
* @see app/Http/Controllers/Admin/SitesController.php:88
* @route '/engine/sites/{site}/notes'
*/
const updateNotesForm = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateNotes.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::updateNotes
* @see app/Http/Controllers/Admin/SitesController.php:88
* @route '/engine/sites/{site}/notes'
*/
updateNotesForm.patch = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateNotes.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateNotes.form = updateNotesForm

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePlan
* @see app/Http/Controllers/Admin/SitesController.php:101
* @route '/engine/sites/{site}/plan'
*/
export const updatePlan = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updatePlan.url(args, options),
    method: 'patch',
})

updatePlan.definition = {
    methods: ["patch"],
    url: '/engine/sites/{site}/plan',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePlan
* @see app/Http/Controllers/Admin/SitesController.php:101
* @route '/engine/sites/{site}/plan'
*/
updatePlan.url = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return updatePlan.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePlan
* @see app/Http/Controllers/Admin/SitesController.php:101
* @route '/engine/sites/{site}/plan'
*/
updatePlan.patch = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updatePlan.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePlan
* @see app/Http/Controllers/Admin/SitesController.php:101
* @route '/engine/sites/{site}/plan'
*/
const updatePlanForm = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updatePlan.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePlan
* @see app/Http/Controllers/Admin/SitesController.php:101
* @route '/engine/sites/{site}/plan'
*/
updatePlanForm.patch = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updatePlan.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updatePlan.form = updatePlanForm

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePaidUntil
* @see app/Http/Controllers/Admin/SitesController.php:117
* @route '/engine/sites/{site}/paid-until'
*/
export const updatePaidUntil = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updatePaidUntil.url(args, options),
    method: 'patch',
})

updatePaidUntil.definition = {
    methods: ["patch"],
    url: '/engine/sites/{site}/paid-until',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePaidUntil
* @see app/Http/Controllers/Admin/SitesController.php:117
* @route '/engine/sites/{site}/paid-until'
*/
updatePaidUntil.url = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return updatePaidUntil.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePaidUntil
* @see app/Http/Controllers/Admin/SitesController.php:117
* @route '/engine/sites/{site}/paid-until'
*/
updatePaidUntil.patch = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updatePaidUntil.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePaidUntil
* @see app/Http/Controllers/Admin/SitesController.php:117
* @route '/engine/sites/{site}/paid-until'
*/
const updatePaidUntilForm = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updatePaidUntil.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SitesController::updatePaidUntil
* @see app/Http/Controllers/Admin/SitesController.php:117
* @route '/engine/sites/{site}/paid-until'
*/
updatePaidUntilForm.patch = (args: { site: number | { id: number } } | [site: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updatePaidUntil.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updatePaidUntil.form = updatePaidUntilForm

const sites = {
    index: Object.assign(index, index),
    updateNotes: Object.assign(updateNotes, updateNotes),
    updatePlan: Object.assign(updatePlan, updatePlan),
    updatePaidUntil: Object.assign(updatePaidUntil, updatePaidUntil),
}

export default sites